<template>
  <div class="relative">
    <input
      type="radio"
      class="radio-button opacity-0 absolute"
      :name="name"
      :id="id"
      :required="required"
      :disabled="disabled"
      :checked="checked"
      :value="value"
      @change="$emit('on-change')"
    />
    <label
      :for="id"
      class="relative flex cursor-pointer px-7 py-3 gap-1 items-center rounded leading-none focus:border-primary border focus:outline-none focus:ring ring-primary text-sm"
      :class="{ 'opacity-50': disabled, 'rounded-3xl': rounded, 'bg-successColor text-white': alternate, 'bg-white text-textPrimary': !alternate, 'w-auto' : labelWidth, 'w-max' : !labelWidth }"
    >
      {{ label }}
      <img
        src="../assets/radio-check.svg"
        alt="Radio"
        class="hidden absolute right-1"
        width="18"
        height="18"
      />
    </label>
  </div>
</template>
<script>
export default {
  name: 'RadioButton',
  props: {
    label: {
      required: true,
      type: String,
    },
    value: {
      required: true,
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
    id: {
      required: true,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
    },
    checked: {
      required: false,
      type: Boolean,
    },
    disabled: {
      required: false,
      type: Boolean,
    },
    rounded: {
      required: false,
      type: Boolean,
    },
    alternate: {
      required: false,
      type: Boolean,
    },
    labelWidth: {
      type: Boolean,
      required: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.radio-button {
  &:focus {
    & + label {
      border: 1px solid var(--primary-color);
      --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
        var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
        calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
      box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
        var(--tw-shadow, 0 0 #0000);
    }
  }
  &:checked {
    & + label > img {
      display: block;
      // color: #3482fd;
      // border: solid 0.05rem #3482fd;
    }
  }
}
</style>
